var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6443 4.53773L14.4895 7.50004L17.4895 15.75L15.2395 18L10.7575 11.4395L8.4895 13.5V15.75L6.2395 18L4.90896 14.0762L0.989502 12.75L3.2395 10.5H5.4895L7.7395 8.25004L0.989502 3.75004L3.2395 1.50004L11.4895 4.50004L14.4624 1.35575L14.3985 1.40905C14.6074 1.19974 14.8554 1.03365 15.1285 0.920272C15.4016 0.806894 15.6943 0.748454 15.99 0.748291C16.2857 0.748129 16.5785 0.806248 16.8517 0.919326C17.1249 1.0324 17.3732 1.19822 17.5822 1.4073C17.7913 1.61638 17.9571 1.86462 18.0702 2.13783C18.1833 2.41103 18.2414 2.70385 18.2412 2.99953C18.2411 3.29521 18.1826 3.58796 18.0693 3.86104C17.9559 4.13412 17.7898 4.38218 17.5805 4.59103L17.6443 4.53773Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.6a44af6bef312a20e0073efd1e554535.svg";
export { ForwardRef as ReactComponent };